// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headerSection {
  height: 51px;
  padding: 16.5px 30px;
  border-bottom: 1px solid #28304C;
  display: flex;
  justify-content: space-between;
}
.headerSection .headerLeftSection {
  padding: 16.5px 4px;
  font-size: 20px;
  font-family: "Poppins";
  font-weight: 600;
  line-height: 22px;
}
.headerSection .headerRightSection {
  display: flex;
}
.headerSection .headerRightSection .profile-button {
  background: #202437;
  padding: 6px 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 309px;
  border-radius: 10px;
}
.headerSection .headerRightSection .profile-button .profile-info {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #fff;
}
.headerSection .headerRightSection .profile-button .profile-info .user-name-text {
  margin-left: 13px;
  font-weight: 600;
  font-family: "Poppins";
  font-size: 16px;
  text-transform: capitalize;
}
.headerSection .headerRightSection .arrow-wrapper {
  width: 24px;
  height: 24px;
  display: inline-block;
}
.headerSection .headerRightSection .settingButton:hover {
  background: none;
}

.css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop {
  position: unset !important;
}`, "",{"version":3,"sources":["webpack://./src/components/HeaderSection/styles.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,oBAAA;EACA,gCAAA;EACA,aAAA;EACA,8BAAA;AACJ;AACI;EACI,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;AACR;AAEI;EACI,aAAA;AAAR;AAEQ;EACI,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;AAAZ;AAEY;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AAAhB;AAEgB;EACI,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,0BAAA;AAApB;AAIQ;EACI,WAAA;EACA,YAAA;EACA,qBAAA;AAFZ;AAKQ;EACI,gBAAA;AAHZ;;AAQA;EACI,0BAAA;AALJ","sourcesContent":[".headerSection {\r\n    height: 51px;\r\n    padding: 16.5px 30px;\r\n    border-bottom: 1px solid #28304C;\r\n    display: flex;\r\n    justify-content: space-between;\r\n\r\n    .headerLeftSection {\r\n        padding: 16.5px 4px;\r\n        font-size: 20px;\r\n        font-family: 'Poppins';\r\n        font-weight: 600;\r\n        line-height: 22px;\r\n    }\r\n\r\n    .headerRightSection {\r\n        display: flex;\r\n\r\n        .profile-button {\r\n            background: #202437;\r\n            padding: 6px 8px;\r\n            display: flex;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            width: 309px;\r\n            border-radius: 10px;\r\n\r\n            .profile-info {\r\n                display: flex;\r\n                flex-direction: row;\r\n                align-items: center;\r\n                color: #fff;\r\n\r\n                .user-name-text {\r\n                    margin-left: 13px;\r\n                    font-weight: 600;\r\n                    font-family: 'Poppins';\r\n                    font-size: 16px;\r\n                    text-transform: capitalize;\r\n                }\r\n            }\r\n        }\r\n        .arrow-wrapper{\r\n            width: 24px;\r\n            height: 24px;\r\n            display: inline-block;\r\n        }\r\n\r\n        .settingButton:hover {\r\n            background: none;\r\n        }\r\n    }\r\n}\r\n\r\n.css-yiavyu-MuiBackdrop-root-MuiDialog-backdrop {\r\n    position: unset !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
